import { Component, OnInit } from '@angular/core';

import { ReportService } from '@services/report.service';

@Component({
  selector: 'app-licence-billing',
  templateUrl: './licence-billing.component.html',
  styleUrls: ['./licence-billing.component.scss']
})
export class LicenceBillingComponent implements OnInit {

    selectedType: string = "billing+debit";
    selectedYear: number;
    selectedMonth: string = "all";

    isLoading: boolean = false;
    archiveYears: number[];
    fullYears: number[];
    partialYears: number[];

    constructor(
        private reportSrv: ReportService
    ) {}

    ngOnInit(): void {
        const minYear = 2019; // first year with results

        const today = new Date();
        const currentYear = today.getFullYear();

        this.selectedType = "billing+debit";
        this.selectedYear = currentYear;
        this.selectedMonth = "all";

        // Fiscal year begins october 2 every year.
        // Select the last complete year.
        if (today.getMonth() < 9)
            this.selectedYear -= 1;
        else if (today.getMonth() === 9 && today.getDate() === 1)
            this.selectedYear -= 1;

        this.archiveYears = [...Array(this.selectedYear - minYear).keys()]
            .map(i => this.selectedYear - i - 1)
            .reverse();
        this.fullYears = [this.selectedYear]
        this.partialYears = [this.selectedYear + 1]
    }

    onSubmit(): void {
        this.isLoading = true;

        const year  = this.selectedYear;
        const month = this.selectedMonth;

        switch (this.selectedType)
        {
            case "billing":
                this.reportSrv.generateXlsBilling(year, month).subscribe(() => this.isLoading = false);
                break;
            case "debit":
                this.reportSrv.generateXlsBillingDebit(year, month).subscribe(() => this.isLoading = false);
                break;
            case "billing+debit":
                this.reportSrv.generateXlsBilling(year, month).subscribe(() =>
                    this.reportSrv.generateXlsBillingDebit(year, month).subscribe(() => this.isLoading = false)
                );
                break;
            case "retrocession":
                this.reportSrv.generateXlsRetrocession(year, month).subscribe(() => this.isLoading = false);
                break;
            default:
                this.isLoading = false;
                break;
        }
    }
}
